// Search Slice
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { EventResponse } from '@/types';

interface SearchState {
  recentSearches: EventResponse[];
  query: string;
}

const initialState: SearchState = {
  recentSearches: [],
  query: '',
};

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    setSearchQuery: (state, action: PayloadAction<string>) => {
      state.query = action.payload;
    },
    addRecentSearch: (state, action: PayloadAction<EventResponse>) => {
      const existingIndex = state.recentSearches.findIndex((item) => item.id === action.payload.id);

      if (existingIndex !== -1) {
        state.recentSearches.splice(existingIndex, 1);
      }

      state.recentSearches.unshift(action.payload);
      state.recentSearches = state.recentSearches.slice(0, 5);
    },
    removeRecentSearch: (state, action: PayloadAction<string>) => {
      state.recentSearches = state.recentSearches.filter((item) => item.id !== action.payload);
    },
    clearRecentSearches: (state) => {
      state.recentSearches = [];
    },
  },
});

export const { addRecentSearch, removeRecentSearch, clearRecentSearches, setSearchQuery } =
  searchSlice.actions;
export default searchSlice.reducer;
